import { isReactive, isRef, markRaw, reactive } from 'vue';

export default {
  updateIsLoading({ commit }, { isLoading = false }) {
    commit('setIsLoading', { isLoading });
  },
  pushModalAlertComponent({ state, commit }, payload) {
    state.modalAlertComponents.push(payload);
    commit('setModalAlertComponents', {
      modalAlertComponents: state.modalAlertComponents
    });
  },
  removeAllModalAlertComponent({ commit }) {
    commit('setModalAlertComponents', {
      modalAlertComponents: []
    });
  },
  closeModalAlertComponent({ state, commit }, { index = 0 }) {
    state.modalAlertComponents.splice(index, 1);
    commit('setModalAlertComponents', {
      modalAlertComponents: state.modalAlertComponents
    });
  },
  pushModalComponent({ state, commit, getters }, payload) {
    payload.component = markRaw(payload.component);
    const data = getters['getModalComponents'];
    if (data.some(obj => obj.component === payload.component)) {
      return false;
    }
    state.modalComponents.push(payload);
    commit('setModalComponents', {
      modalComponents: state.modalComponents
    });
  },
  removeAllModalComponent({ commit }) {
    commit('setModalComponents', {
      modalComponents: []
    });
  },
  closeModalComponent({ state, commit }, { index = 0 }) {
    state.modalComponents.splice(index, 1);
    commit('setModalComponents', {
      modalComponents: state.modalComponents
    });
  },
  updateRouteLayout({ commit }, payload) {
    commit('setRouteLayout', payload);
  },
  updateKeywords({ getters, commit }, { keyword }) {
    const keywords = getters.getKeywords;
    keywords.unshift(keyword);
    commit('setKeywords', { keywords });
  },
  async setHeader({ getters, commit }, flag) {
    commit('setIsHeader', flag);
  }
};

const isVueComponent = obj => {
  return obj && typeof obj === 'object' && obj.hasOwnProperty('component') && obj.hasOwnProperty('data');
};
